import { AffectedStaffContact } from '../../lib/types/models/affectedStaff/affected-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAffectedStaffContacts(affectedStaffId: number) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.getAffectedStaffContacts.url, { id: affectedStaffId }))
    .get<AffectedStaffContact[]>()
}
